import { router } from '@codesuma/baseline'
import { IconButton } from '../icon-button'
import { Bar } from '../bar'
import style from './index.module.css'

export const MenuIcon = () => {

    const base = IconButton()
    base.addClass(style.base)

    // --brand-icon is the brand purple on light, a light lavender on the night sky.
    const top = Bar(4, { bg: 'var(--brand-icon)' })
    const middle = Bar(4, { bg: 'var(--brand-icon)' })
    const bottom = Bar(4, { bg: 'var(--brand-icon)' })
    top.style({ width: '50%' })
    bottom.style({ width: '80%' })
    base.append(top, middle, bottom)

    // Slide in only on the home route; tuck away elsewhere.
    router.on('change', ({ path }: any) => path.split('?')[0] === '/' ? show() : hide())

    function show() {
        setTimeout(() => {
            base.style({
                opacity: '1',
                transform: 'translateY(0)'
            })
        }, 100)
    }
    function hide() {
        base.style({
            opacity: '0',
            transform: 'translateY(-60px)'
        })
    }


    return base
}
